module.exports = __webpack_public_path__ + "img/passionsaltar.a067d852.jpg";